import { OnboardingSubmissionList } from '@/components/OnboardingSubmissionList';
import TabLayout from '@/components/TabLayout';
import { useAsyncEffect } from '@/hooks/useAsyncEffect';
import { useStores } from '@/store';
import { observer } from 'mobx-react';
import React from 'react';
import { Link, useLocation } from 'react-router';
import { Label, Menu } from 'semantic-ui-react';

export const OnboardingSubmissions = observer(() => {
  const { pathname } = useLocation();
  const { temporaryEmployeeStore } = useStores();

  useAsyncEffect(async () => {
    await temporaryEmployeeStore.fetchCount();
  }, []);

  const panes = [
    {
      route: 'submitted',
      menuItem: (
        <Menu.Item as={Link} to="/onboarding/submissions/submitted" key="submitted">
          Submitted
          <Label color="yellow" floating circular>
            {temporaryEmployeeStore.submittedCount}
          </Label>
        </Menu.Item>
      ),
      render: () => <OnboardingSubmissionList status="submitted" />,
    },
    {
      route: 'approved',
      menuItem: (
        <Menu.Item as={Link} to="/onboarding/submissions/approved" key="approved">
          Approved
          <Label color="yellow" floating circular>
            {temporaryEmployeeStore.approvedCount}
          </Label>
        </Menu.Item>
      ),
      render: () => <OnboardingSubmissionList status="approved" />,
    },
    {
      route: 'active',
      menuItem: (
        <Menu.Item as={Link} to="/onboarding/submissions/active" key="active">
          Active
          <Label color="yellow" floating circular>
            {temporaryEmployeeStore.activeCount}
          </Label>
        </Menu.Item>
      ),
      render: () => <OnboardingSubmissionList status="active" />,
    },
  ];

  return (
    <TabLayout
      linkTitle="Onboarding Submissions"
      panes={panes}
      path={pathname}
      activeBreadcrumb="Onboarding Submissions"
    />
  );
});
